module.exports = __webpack_public_path__ + "media/images/sp/brands/common/brand_menu_location_studio_plans-9b9f36de4216fd18273941e37d0d5a26.jpg";